'use strict';

wbApp.controller('UsersConsentsCtrl', ['$scope', '$http', '$q', '$modal', '$translate', '$filter', 'messageBoxSvc',
    'consentSvc', 'gridSortSvc', 'securitySvc', 'userSvc', 'consentDefinitionSvc',
function ($scope, $http, $q, $modal, $translate, $filter, messageBoxSvc,
    consentSvc, gridSortSvc, securitySvc, userSvc, consentDefinitionSvc) {

    $scope.filteredUsers = [];
    $scope.selectedUser = null;
    $scope.usersConsents = [];

    $scope.customFileter = { consentDefinitionID: null };


    $scope.tabs = [
        {
            title: 'TXT_DETAIL',
            template: "users/users-consents/detail-tabs/users-consents-detail.html"
        }
    ];

    $scope.gridSettings = {
        name: 'usersConsents',
        columns: [
            {
                dataField: 'fullName', caption: $translate.instant('TXT_HUMAN_NAME'), dataType: 'string', sortOrder: 'asc',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName(data, 'name', 'surname', 'middleName') }
            },
            { dataField: 'email', caption: $translate.instant('TXT_LBL_EMAIL'), dataType: 'string', width: '180px' },
            {
                dataField: 'phone',
                caption: $translate.instant('TXT_LBL_PHONE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('phone')(rowData.phone);
                },
                width: '140px'
            },
            { dataField: 'customConsent', caption: $translate.instant("TXT_LBL_IDM_CONSENT"), dataType: 'datetime', format: { date: 'short' }, width: '90px', visible: false  },
            { dataField: 'idmEmailConfirmed', caption: $translate.instant('TXT_IDENTITY_CONFIRMED'), dataType: 'boolean', width: '90px' },
            { dataField: 'isDisabled', caption: $translate.instant('TXT_DISABLED'), dataType: 'boolean', width: '60px' },
        ],
        onInitialized: function (e) {
            $scope.dataGridInstance = e.component;          
        },
        onRowPrepared: function (e) {
            if (e.rowType == "data") {
                var data = e.component.getKeyByRowIndex(e.rowIndex);
                if (!data.idmConsentIssued) {
                    e.rowElement.addClass('text-danger');
                }
            }
        },
        customCommands: [{
            text: $translate.instant('TXT_LBL_CONSENTS_DEFINITIONS'),
            isVisible: function (row) { return securitySvc.isInRole('ConsentDefinition'); },
            callback: function (row) {
                $scope.showConsentsDefinitionsDetail();
            }
        }, {
            text: $translate.instant('TXT_LBL_REQUEST_CONSENT'),
            isVisible: function (row) { return securitySvc.isInRole('ConsentDefinition') && !!$scope.selectedUser; },
            callback: function (row) {
                $scope.requestConsentsFromAll([$scope.selectedUser]);
            }
        }, {
            text: $translate.instant('TXT_LBL_REQUEST_CONSENT_FROM_ALL'),
            isVisible: function (row) { return securitySvc.isInRole('ConsentDefinition'); },
            callback: function (row) {
                $scope.requestConsentsFromAll($scope.filteredUsers);
            }
        }, {
            text: $translate.instant('TXT_LBL_ANONYMIZE_DATA'),
            isVisible: function (row) { return securitySvc.isInRole('User.Anonymize'); },
            callback: function (row) {
                $scope.requestAnonimizeData($scope.selectedUser);
            }
        }]

    }

    $scope.$watch('customFilter.consentDefinitionID', function (newValue, oldValue) {
        if (newValue) {
            _.forEach($scope.usersConsents, function (item) {
                var idx = _.findIndex(item.consents, { 'consentDefinitionID': newValue });
                if (idx !== -1) {
                    item.customConsent = item.consents[idx].consentRatifiedTo;
                } else {
                    item.customConsent = null;
                }
            });

            if ($scope.dataGridInstance) {
                $scope.dataGridInstance.columnOption("customConsent", "visible", true);

                consentDefinitionSvc.getConsentNameByIDAsync(newValue).then(function (consent) {
                    $scope.dataGridInstance.columnOption("customConsent", "caption", consent.name);
                });
            }
        } else {
            if ($scope.dataGridInstance) {
                $scope.dataGridInstance.columnOption("customConsent", "visible", false);
            }

            _.forEach($scope.usersConsents, function (item) {
                item.customConsent = null;
            });
        }
    }, true);

    function setSelectedUser(data) {
        $scope.selectedUser = data;
        $scope.$broadcast('userConsentSelectionChanged', data);
    }

    function loadData(refresh) {
        $scope.usersConsents = consentSvc.getConsentsInfoBrief(refresh);        
    }

    loadData(true);

    $scope.$on('refreshData', function (e, data) {
        loadData(true);

        setSelectedUser(null);
    });

    $scope.onFilterApplied = function (rows) {
        $scope.filteredUsers = rows;
    }

    $scope.onRowSelected = function (data) {
        setSelectedUser(data);
    }

    $scope.requestConsentsFromAll = function (selectedUsers) {
        requestConsentFromAllDialog.$promise.then(function () {
            requestConsentFromAllDialog.$scope.selectedUsers = selectedUsers;
            requestConsentFromAllDialog.show();
        });
    }


    $scope.showConsentsDefinitionsDetail = function () {
        consentsDefinitions.$promise.then(function () {
            consentsDefinitions.show();
        });
    }

    $scope.requestAnonimizeData = function (user) {

        function onYesClicked() {
            userSvc.anonymize(user.userID, false, function () {
                loadData(refresh);
            });
        }

        function onYesWithTaxDocumentClicked() {
            userSvc.anonymize(user.userID, true, function () {
                loadData(refresh);
            });
        }

        messageBoxSvc.showMessageDlg({
            title: 'TXT_ANONYMIZE_CONFIRM_TITLE',
            message: $translate.instant('TXT_ANONYMIZE_CONFIRM_DESC').f(user.fullName),
            buttons: [{
                text: 'TXT_BTN_YES',
                callback: onYesClicked,
                danger: true
            }, {
                text: 'TXT_BTN_YES_WITH_TAX_DOCUMENTS',
                callback: onYesWithTaxDocumentClicked,
                danger: true
            }, {
                text: 'TXT_BTN_NO',
                primary: true
            }]
        });
    }

    var consentsDefinitions = $modal({
        templateUrl: 'users/users-consents/consents-definitions.html',
        show: false,
        scope: $scope.$new()
    });

    var requestConsentFromAllDialog = $modal({
        templateUrl: 'users/users-consents/request-consent-from-all.html',
        show: false,
        scope: $scope.$new()
    });
}]);


